import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { resolveSyncDisplay, type SyncStatus } from './SyncStatus.utils';

interface SyncStatusIconProps {
  /** API sync status value
   (e.g. 'synced', 'not_synced', 'pending', etc.).
   Case-insensitive. Unrecognized or missing values will show a fallback "unknown" status.
  **/
  status?: SyncStatus | (string & {});
  //Override the default translated tooltip.
  tooltip?: string;
  //Font size passed to the MUI icon. @default 'small'
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
}

export function SyncStatusIcon({ status, tooltip, fontSize = 'small' }: SyncStatusIconProps) {
  const { t } = useTranslation('common');
  const config = resolveSyncDisplay(status);
  const Icon = config.icon;
  const label = tooltip ?? t(config.tooltipKey);

  return (
    <Tooltip title={label}>
      <span
        role="img"
        aria-label={label}
        data-testid="sync-status-icon"
        data-status={status ?? 'unknown'}
        tabIndex={0}
      >
        <Icon color={config.color} fontSize={fontSize} />
      </span>
    </Tooltip>
  );
}
